import React from 'react';
import { Link } from 'react-router';
import ReactMarkdown from 'react-markdown';
import { Col, Row } from 'react-bootstrap';
import { Button } from '../../../../common/components';
import MultipleInsurerDocuments from './components/MultipleInsurerDocuments/MultipleInsurerDocuments';
import { ICON_MAP } from '../../../../common/components/SvgIcons/productIcons';

const ProductDetails = ({ product }) => {


  const MappedIcon = () => ICON_MAP[product.attributes.product_code];

  return (
    <Row className="product">
      <Col xs={12} className={'name-container'}>
        <MappedIcon />
        <h3 className={'name'}>{product.attributes.name}</h3>
      </Col>
      <Col xs={12} className={'description d-none'}>
        <ReactMarkdown source={product.attributes.description} />
      </Col>
      <Col xs={12} className={'product-document-container'}>
        <MultipleInsurerDocuments
          productId={product.id}
        />
      </Col>
      <Col xs={12} className={'call-to-action-container'}>
        <Link className={'link'} to={'products/' + product.id + '/quote'} onlyActiveOnIndex>
          <Button bsStyle="primary">Get a quote</Button>
        </Link>
      </Col>
    </Row>
  );
};

export default ProductDetails;
